import axios from 'axios';
import {useEffect, useState} from 'react';
import {useKeycloak} from "@react-keycloak/web";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const REQUEST_TIMEOUT = 180000;

const axiosDefaultConfig = {
    baseURL: API_BASE_URL,
    withCredentials: true,
    timeout: REQUEST_TIMEOUT,
};

export const useAxios = () => {
    const {keycloak, kInitialized} = useKeycloak();
    const [initialized, setInitialized] = useState(false);
    const [axiosInstance, setAxiosInstance] = useState({});

    useEffect(() => {
        const cfg = {
            ...axiosDefaultConfig,
            headers: {
//                ...(config.headers || {}),
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Credentials': 'true',
                'Content-Type': 'application/json',
                'Authorization': keycloak.authenticated ? `Bearer ${keycloak.token}` : undefined,
            },
        }

        setAxiosInstance({instance: axios.create(cfg)});
        setInitialized(true);
    }, [keycloak.token, kInitialized, keycloak.authenticated]);

    return {axios: axiosInstance.instance, initialized};
};

